// types
import { DefaultConfigProps, MenuOrientation, ThemeDirection, ThemeMode } from 'types/config';

// ==============================|| THEME CONSTANT ||============================== //

// export const twitterColor = '#1DA1F2';
// export const facebookColor = '#3b5998';
// export const linkedInColor = '#0e76a8';

export const APP_DEFAULT_PATH = '/overview';
export const HORIZONTAL_MAX_ITEM = 6;
export const DRAWER_WIDTH = 280;
export const MINI_DRAWER_WIDTH = 90;
export const HEADER_HEIGHT = 74;
export const USE_INTERCOM = false;
export const USE_SIDEBAR_LOGO_V3_TEST = false;
export const HABIHUB_LOGO_V3_ENABLED = true;
export const HABIHUB_LOGO_V3_AGENT_IDS: string[] = ['b12960be-a001-70c4-1029-7385525c31e4', '8a3b3808-285e-488e-b06c-a3cb3bb7f6df'];
export const hasHabihubLogoV3 = (agentId?: string | null) =>
  HABIHUB_LOGO_V3_ENABLED || Boolean(agentId && HABIHUB_LOGO_V3_AGENT_IDS.includes(agentId));
export const HABIHUB_BRAND_COLORS = {
  gradientStart: '#673dfe',
  gradientEnd: '#cb449a'
};
export const HABIHUB_LOGO_V3_BRAND_COLORS = {
  gradientStart: '#3700ff',
  // originalGradientEnd: '#ff00a2',
  gradientEnd: '#d43b99'
};
export const HABIHUB_SWITCH_COLORS_BY_THEME = false;
export const getHabihubBrandColors = (agentId?: string | null) =>
  hasHabihubLogoV3(agentId) ? HABIHUB_LOGO_V3_BRAND_COLORS : HABIHUB_BRAND_COLORS;
export const getHabihubBrandGradient = (brandColors: typeof HABIHUB_BRAND_COLORS, percentage: number) =>
  `linear-gradient(90deg, ${brandColors.gradientStart} ${100 - percentage}%, ${brandColors.gradientEnd} 100%)`;
export const SUPPORT_WHATSAPP_PHONE = '34644111763';
export const SUPPORT_WHATSAPP_URL = `https://wa.me/${SUPPORT_WHATSAPP_PHONE}`;

// ==============================|| PORTAL - ROUTING + LANGUAGES ||============================== //
export const PORTAL_ROUTING: any = {
  development: {
    cs: '/cs/agentura/{agentId}/nove-stavby/{developmentId}',
    da: '/da/agentur/{agentId}/nybyggeri/{developmentId}',
    de: '/de/agentur/{agentId}/neubau/{developmentId}',
    el: '/el/praktoras/{agentId}/nea-kataskeyi/{developmentId}',
    en: '/en/agency/{agentId}/new-build/{developmentId}',
    es: '/agencia/{agentId}/obra-nueva/{developmentId}',
    fi: '/fi/toimisto/{agentId}/uudisrakentaminen/{developmentId}',
    fr: '/fr/agence/{agentId}/nouvelle-construction/{developmentId}',
    it: '/it/agenzia/{agentId}/nuove-costruzioni/{developmentId}',
    nl: '/nl/agentschap/{agentId}/nieuwbouw/{developmentId}',
    no: '/no/byra/{agentId}/nybygg/{developmentId}',
    pl: '/pl/agencja/{agentId}/nowe-budownictwo/{developmentId}',
    pt: '/pt/agencia/{agentId}/empreendimentos-novos/{developmentId}',
    ka: '/ka/saagento/{agentId}/akhali-mshenebloba/{developmentId}',
    ro: '/ro/agentie/{agentId}/constructii-noi/{developmentId}',
    ru: '/ru/agentstvo/{agentId}/novostrojki/{developmentId}',
    sv: '/sv/byra/{agentId}/nyproduktion/{developmentId}',
    uk: '/uk/ahentstvo/{agentId}/novobudovy/{developmentId}'
  },
  offer: {
    cs: '/cs/agentura/{agentId}/nabidka/{offerId}',
    da: '/da/agentur/{agentId}/tilbud/{offerId}',
    de: '/de/agentur/{agentId}/angebot/{offerId}',
    el: '/el/praktoras/{agentId}/prosfora/{offerId}',
    en: '/en/agency/{agentId}/offer/{offerId}',
    es: '/agencia/{agentId}/oferta/{offerId}',
    fi: '/fi/toimisto/{agentId}/tarjous/{offerId}',
    fr: '/fr/agence/{agentId}/offre/{offerId}',
    it: '/it/agenzia/{agentId}/offerta/{offerId}',
    nl: '/nl/agentschap/{agentId}/aanbieding/{offerId}',
    no: '/no/byra/{agentId}/tilbud/{offerId}',
    pl: '/pl/agencja/{agentId}/oferta/{offerId}',
    pt: '/pt/agencia/{agentId}/oferta/{offerId}',
    ka: '/ka/saagento/{agentId}/shethavazeba/{offerId}',
    ro: '/ro/agentie/{agentId}/oferta/{offerId}',
    ru: '/ru/agentstvo/{agentId}/predlozhenie/{offerId}',
    sv: '/sv/byra/{agentId}/erbjudande/{offerId}',
    uk: '/uk/ahentstvo/{agentId}/propozytsiya/{offerId}'
  }
};

export const PORTAL_LANGUAGES: any = [
  { code: 'en', name: 'English', flag: 'GB' },
  { code: 'es', name: 'Español', flag: 'ES' },
  { code: 'de', name: 'Deutsch', flag: 'DE' },
  { code: 'fr', name: 'Français', flag: 'FR' },
  { code: 'it', name: 'Italiano', flag: 'IT' },
  { code: 'nl', name: 'Nederlands', flag: 'NL' },
  { code: 'pt', name: 'Português', flag: 'PT' },
  { code: 'ka', name: 'ქართული', flag: 'GE' },
  { code: 'pl', name: 'Polski', flag: 'PL' },
  { code: 'cs', name: 'Čeština', flag: 'CZ' },
  { code: 'da', name: 'Dansk', flag: 'DK' },
  { code: 'fi', name: 'Suomi', flag: 'FI' },
  { code: 'el', name: 'Ελληνικά', flag: 'GR' },
  { code: 'no', name: 'Norsk', flag: 'NO' },
  { code: 'ro', name: 'Română', flag: 'RO' },
  { code: 'ru', name: 'Русский', flag: 'RU' },
  { code: 'sv', name: 'Svenska', flag: 'SE' },
  { code: 'uk', name: 'Українська', flag: 'UA' }
];

export function getLocalizedPath(
  type: 'offer' | 'development',
  lang: string,
  ids: { agentId: string; offerId?: string; developmentId?: string }
): string {
  const template = PORTAL_ROUTING[type][lang];
  if (!template) return '#';

  return template
    .replace('{agentId}', ids.agentId)
    .replace('{offerId}', ids.offerId || '')
    .replace('{developmentId}', ids.developmentId || '');
}

// ==============================|| THEME CONFIG ||============================== //

const config: DefaultConfigProps = {
  fontFamily: `Inter var`,
  // i18n: 'en',
  i18n: 'es',
  menuOrientation: MenuOrientation.VERTICAL,
  menuCaption: true,
  miniDrawer: false,
  container: false,
  mode: ThemeMode.LIGHT,
  presetColor: 'default',
  themeDirection: ThemeDirection.LTR,
  themeContrast: false
};

export default config;
